<!-- Menu header -->
<div class="navbar-header" style="height: 105px;">
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
            <!-- App Branding -->
            <a class="navbar-brand" [routerLink]="['/']">
                <img width="100%" src="assets/images/logo/center_logo.png" alt="brand-logo" />
<!--                <img src="./assets/images/logo/logoBIGPUNTOS.png" alt="brand-logo" width="30%" />-->
            </a>
        </li>

        <!-- Menu Toggler -->
    </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>

<!-- Main menu -->
<!--<div class="main-menu-content" [perfectScrollbar] (scroll)="onSidebarScroll()">-->
<!--    <ul class="navigation navigation-main" layout="vertical" core-menu></ul>-->
<!--</div>-->
<div style="position: relative; max-width: 100%; max-height: 85%;" (scroll)="onSidebarScroll()" [perfectScrollbar]>
    <ul class="navigation navigation-main" layout="vertical" core-menu></ul>
</div>
<!--/ Main menu -->
